const useContentOfCompaign = ({
  listOfContentsInCampaign,
  customContents,
  initialBackup,
  editCampaignActive,
  hasInitialBackup,
  groupedDisplays,
  cart,
  listResolutionWithContent,
  setListResolutionWithContent,
  updateListOfContentsInCampaign,
  updateCustomContents,
  applyRelationOnScreens,
  restoreCampaignToOriginalState,
  clearCustomContents,
  cleanListOfContentsInCampaign,
  // from modal state
  showModalCleanContent,
  setResolutionFilterIndex,
  setVersionFilter,
  contentToCloneName,
  cancelModalCloneNameContent
}) => {
  const isInitialBackupUnchanged = () => {
    if (!initialBackup) return false;
    return (
      JSON.stringify(listOfContentsInCampaign) ===
        JSON.stringify(initialBackup.listOfContentsInCampaign) &&
      JSON.stringify(customContents) === JSON.stringify(initialBackup.customContents)
    );
  };

  const clearProgressDisabled = () => {
    if (editCampaignActive && isInitialBackupUnchanged()) return true;
    if (listOfContentsInCampaign.length === 0) return true;
    return false;
  };

  const handleContent = (value, content) => {
    const updatedContent = { ...content, name: value };
    updateListOfContentsInCampaign(updatedContent);

    const updatedList = listResolutionWithContent.map(relation => ({
      ...relation,
      contents: relation.contents.map(item =>
        item.id === content.id ? { ...item, name: value } : item
      )
    }));
    setListResolutionWithContent(updatedList);

    if (groupedDisplays) {
      applyRelationOnScreens(cart, updatedList);
    }
  };

  const cleanProgress = () => {
    if (editCampaignActive && hasInitialBackup) {
      restoreCampaignToOriginalState();
      setResolutionFilterIndex(null);
      setVersionFilter(null);
    } else {
      cleanListOfContentsInCampaign();
      clearCustomContents();
    }
    showModalCleanContent();
  };

  const cloneNameToAllVersions = () => {
    if (!contentToCloneName) return;

    const updatedContents = listOfContentsInCampaign.map(content => {
      if (content.content_version_name === contentToCloneName.content_version_name) {
        return { ...content, name: contentToCloneName.name };
      }
      return content;
    });
    updatedContents.forEach(content => updateListOfContentsInCampaign(content));

    const updatedList = listResolutionWithContent.map(relation => ({
      ...relation,
      contents: relation.contents.map(item =>
        item.content_version_name === contentToCloneName.content_version_name
          ? { ...item, name: contentToCloneName.name }
          : item
      )
    }));
    setListResolutionWithContent(updatedList);

    if (groupedDisplays) {
      applyRelationOnScreens(cart, updatedList);
    }

    cancelModalCloneNameContent();
  };

  return {
    isInitialBackupUnchanged,
    clearProgressDisabled,
    handleContent,
    cleanProgress,
    cloneNameToAllVersions
  };
};

export default useContentOfCompaign;
